// src/components/ui/Banner.jsx
// Banner reutilizável (sucesso/erro/info/warning) — substitui Banner inline duplicado em várias views.
import React from "react";

const CORES = {
  error:   { bg: "#FEE2E2", border: "#FECACA", color: "#991B1B", icon: "bi-exclamation-octagon" },
  danger:  { bg: "#FEE2E2", border: "#FECACA", color: "#991B1B", icon: "bi-exclamation-octagon" },
  success: { bg: "#DCFCE7", border: "#BBF7D0", color: "#166534", icon: "bi-check-circle" },
  info:    { bg: "#EFF6FF", border: "#BFDBFE", color: "#1D4ED8", icon: "bi-info-circle" },
  warning: { bg: "#FEF3C7", border: "#FDE68A", color: "#92400E", icon: "bi-exclamation-triangle" },
};

export default function Banner({ tipo = "info", children, onClose, style }) {
  if (!children) return null;
  const c = CORES[tipo] || CORES.info;
  return (
    <div
      role="status"
      style={{
        background: c.bg,
        border: `1px solid ${c.border}`,
        color: c.color,
        borderRadius: 8,
        padding: "10px 14px",
        marginBottom: 12,
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 13.5,
        ...(style || {}),
      }}
    >
      <i className={`bi ${c.icon}`} style={{ fontSize: 18 }} />
      <div style={{ flex: 1 }}>{children}</div>
      {onClose && (
        <button
          type="button"
          className="btn btn-sm"
          style={{ padding: "2px 8px", background: "transparent", color: c.color }}
          onClick={onClose}
          aria-label="Fechar"
        >
          <i className="bi bi-x-lg" />
        </button>
      )}
    </div>
  );
}
